import React from "react";
import CrearPeriodo from "../components/Parametros/CrearPeriodo";

const AddPeriodPage = () => {
  return <CrearPeriodo />;
};

export default AddPeriodPage;
